import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import OnboardingAssignment from "../../interfaces/OnboardingAssignment";
import { dispatch } from "../configureStore";

export interface ReadleeSettingsState {
  dirtyDefinitions: Array<string>;
  onboardingAssignments: Array<OnboardingAssignment>;
  demoStudents: Array<string>;
  demoAssignments: Array<string>;
  demoClassId: string;
  cloningFinished: boolean;
  adminId: string;
}

const initialState: ReadleeSettingsState = {
  dirtyDefinitions: [],
  onboardingAssignments: [],
  demoStudents: [],
  demoAssignments: [],
  demoClassId: "",
  cloningFinished: true,
  adminId: "",
};

const slice = createSlice({
  name: "readleeSettingsState",
  initialState,
  reducers: {
    setDirtyWords: (state, action: PayloadAction<Array<string>>) => {
      state.dirtyDefinitions = action.payload;
    },
    setOnboardingAssignments: (state, action: PayloadAction<Array<OnboardingAssignment>>) => {
      state.onboardingAssignments = action.payload;
    },
    setDemoStudents: (state, action: PayloadAction<Array<string>>) => {
      state.demoStudents = action.payload;
    },
    setDemoAssignments: (state, action: PayloadAction<Array<string>>) => {
      state.demoAssignments = action.payload;
    },
    setDemoClassId: (state, action: PayloadAction<string>) => {
      state.demoClassId = action.payload;
    },
    setCloningFinished: (state, action: PayloadAction<boolean>) => {
      state.cloningFinished = action.payload;
    },
    setAdminId: (state, action: PayloadAction<string>) => {
      state.adminId = action.payload;
    },
  },
});

export const setDirtyWords = (words: Array<string>) => {
  dispatch(slice.actions.setDirtyWords(words));
};

export const setOnboardingAssignments = (assignments: Array<OnboardingAssignment>) => {
  dispatch(slice.actions.setOnboardingAssignments(assignments));
};

export const setDemoStudents = (students: Array<string>) => {
  dispatch(slice.actions.setDemoStudents(students));
};

export const setDemoAssignments = (assignments: Array<string>) => {
  dispatch(slice.actions.setDemoAssignments(assignments));
};

export const setDemoClassId = (id: string) => {
  dispatch(slice.actions.setDemoClassId(id));
};

export const setCloningFinished = (result: boolean) => {
  dispatch(slice.actions.setCloningFinished(result));
};

export const setAdminId = (id: string) => {
  dispatch(slice.actions.setAdminId(id));
};

export default slice.reducer;
